module.exports = __webpack_public_path__ + "od-delivery-truck-1-icon/od-delivery-truck-1-icon-9e0051b1ab32b2ed5b984d4e8118bc2a.svg";